
import { mapGetters } from 'vuex';
import { formatData } from '../../constants/config.js';
export default {
    props: ['idForm', 'dataAddress', 'dataListCountries', 'dataListStates', 'dataListPhoneCodes', 'typeForm'],
    components: {
        vcFormField		: () => import('../../components/pages/form-field.vue')
    },
    data() {
        return {
            addressForm         : this.dataAddress,
            listCountries       : [],
            listStates          : [],
            listPhoneCodes      : [],
            listStatesByCountry : [],
            
            update_phone        : {
                code        : '52',
                country_code: 'MX',
                number      : '',
                format      : ''
            },
            
            actionForm          : null
        }
    },
    async mounted(){
        this.listStates     = this.dataListStates       || [];
        this.listCountries  = this.dataListCountries    || [];
        this.listPhoneCodes = this.dataListPhoneCodes   || [];
        this.filterStates( this.addressForm.country_code );                
        this.$root.$on('change-select-address'  , this.updateSelectedAddress);
        this.$root.$on('valid-address'          , this.executeValidAddress);
        this.$root.$on('reset-address'          , this.resetAddress);
        this.$root.$on('update-field-value'     , this.updateFieldValue);
    },
    computed: {
        ...mapGetters({
            getterStoreLang : 'getterStoreLang',
			getterTranslates: 'getterTranslates',
            getterCustomer  : 'getterCustomer',
        }),
        getAddress(){
            return this.addressForm;
        },
        getPhoneData(){
            return this.update_phone;
        },
    },
    methods: {
        updateFieldValue(data){

            if( data.field === 'phone' ){
                this.update_phone       = data.value;
                this.addressForm.phone  = data.value;
            }
            else if( data.field === 'country_code' && this.listCountries.find( (item) => item.id === data.value ) ){
                this.filterStates( data.value );
                this.addressForm.country_code = data.value;
            }
            else if( data.field === 'state_code' && this.listStatesByCountry.find( (item) => item.id === data.value ) ){
                this.selectState( data.value );
                this.addressForm.state_code = data.value;
            }
            else if( data.field === 'google_country_state_code' ){
                if( this.listCountries.find( (item) => item.id === data.value.country_code ) ){
                    this.filterStates( data.value.country_code );
                    this.addressForm.country_code = data.value.country_code;
                    if( this.listStatesByCountry.find( (item) => item.id === data.value.state_code ) ){
                        this.selectState( data.value.state_code );
                        this.addressForm.state_code = data.value.state_code;
                    }
                }
            }
            else{
                this.addressForm[data.field] = data.value;
            }
        },
        updateSelectedAddress( data_select ){
            if( this.idForm === data_select.id_form ){
                
                this.addressForm = data_select.address;
    
                const currentCountry = this.listCountries.find( (item) => item.id === this.addressForm.country_code );
                this.addressForm.country = currentCountry ? currentCountry.label : this.addressForm.country;
                this.addressForm.country_code = currentCountry?.id ? currentCountry.id : this.addressForm.country_code;

                const phone = this.addressForm?.phone || this.getterCustomer.phone || null
                this.update_phone = formatData.validPhoneNumber(phone, this.listPhoneCodes)

                this.addressForm.phone = this.update_phone;
                this.filterStates( this.addressForm.country_code );
            }
        },
        filterStates(country_id) {
            
            let itemCountry = this.listStates.find( (item) => item.id === country_id );
            
            this.$root.$emit('update-country-address', country_id);
            this.$root.$emit('update-state-address', this.addressForm.state_code);
            
            let exist_state = itemCountry ? itemCountry.states.some( (item) => item.id === this.addressForm.state_code) : false;
            
            this.listStatesByCountry        = itemCountry ? itemCountry.states: [];
            
            this.addressForm.state          = !exist_state ? ( this.listStatesByCountry.length > 0 && this.typeForm != 'register-customer' ? this.listStatesByCountry[0].label : null ) : this.addressForm.state;
            this.addressForm.state_code     = !exist_state ? ( this.listStatesByCountry.length > 0 && this.typeForm != 'register-customer' ? this.listStatesByCountry[0].id : null ) : this.addressForm.state_code;
            
            this.addressForm.country_code   = itemCountry ? itemCountry.id      : null;
            this.addressForm.country        = itemCountry ? itemCountry.label   : null;
        },
        selectState(state_id) {
            
            let itemState = this.listStatesByCountry.find( (item) => item.id === state_id );
            
            this.addressForm.state      = itemState ? itemState.label   : null;
            this.addressForm.state_code = itemState ? itemState.id      : null;
        },
        executeValidAddress(data_form){
            
            if( data_form.id_form === this.idForm ){
                
                this.actionForm = data_form.action;
                document.getElementById(`btn-${ data_form.id_form }`).click();
            }
        },
        resetAddress(data_form){
            
            if( data_form.clean ){
                
                this.filterStates('MX');
                this.addressForm        = {
                    id              : null,
                    customer_id     : null,
                    default         : false,
                    default_shipping: false,
                    default_billing : false,
                    first_name      : '',
                    last_name       : '',
                    name            : '',
                    phone           : '',
                    address_1       : '',
                    address_2       : '',
                    company         : '',
                    country         : 'Mexico',
                    country_code    : 'MX',
                    state           : null,
                    state_code      : null,
                    city            : '',
                    zip             : ''
                };
                this.update_phone       = {
                    code        : '52',
                    country_code: 'MX',
                    number      : '',
                    format      : ''
                };
            }
            document.getElementById(`reset-form-${ data_form.id_form }`).click();
        },
        preSubmit(is_valid){
            
            if( this.actionForm ){
                
                this.$root.$emit('valid-form-address', { id_form: this.idForm, address: this.getAddress, valid: is_valid, valid_zip_code: true, action: this.actionForm });
            }
            this.actionForm = null;
        }
    }
}
